<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
      <div slot="content">
        <div class="pop-content-search">
          <el-form size="mini" label-width="80px" style="margin-left: -40px;">
            <el-row style="margin-bottom: 0px;">
              <el-col :span="12">
                <el-form-item label="제품군명">
                  <el-row>
                    <el-col :span="16">
                      <el-input type="text" v-model="modelNm"/>
                    </el-col>
                    <el-col :span="8">
                      <el-button type="primary" icon="el-icon-search" @click="goOpen"></el-button>
                      <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 320px;"
                class="ag-theme-alpine"
                row-selection="single"

                :column-defs="columnDefs"
                :frameworkComponents="frameworkComponents"
                :grid-options="gridOptions"
                :row-data="rowData"
                :default-col-def="defaultColDef"
                @grid-ready="onGridReady"
                @cell-clicked="onCellClicked" />
          </div>
        </div>
      </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

/**
 * * Tab 구분 컴포넌트
 */

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
    mixins: [],
    props: {
        data: {
            Type: Array
            , required: false
        },
        title: {
            Type: String
            , required: false
        }
    },
    components: {Layout},
    data() {
        return {
            rowData:[],
            gridOptions: {},

            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */

          columnDefs:[
            {
              headerName: '선택'
              , field:'regYn'
              , width : 100
              , editable: false
              , cellRenderer: 'checkboxRenderer'
              , cellRendererParams: {
                trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
              },
            },
            {
              headerName: '제품군',
              width:170,
              field:'value',
              cellStyle:{textAlign:'center'}
            },
          ],
          defaultColDef: {
            resizable: true,
            filter:true,
            sortable: true
          },
        }
    },
    created() {
        
        this.$bus.$on('input', (val) => {
            console.log('-> input bus on ', val);
        });
    },
    beforeMount() {

      this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
        checkboxRenderer: CheckboxCellRenderer,
      };

    },
    mounted() {
      // this.form = this.data[0].param

      // this.getCombo({flag: 'INIT'})

      //pop slots modal move
      $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        onGridReady(){
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        onModelGroupChange(e){

        },
        onCellClicked(param){
          // this.$emit('close', param)
          // this.closeModal()
        },
        save() {

          const grid = this.$refs.gridSub
          const chkDatas = grid.rowData.filter((x,i) => {
            return x.regYn === "Y"
          })

          this.$emit('close', chkDatas);
          this.closeModal();
        },
        goOpen(){
          this.$store.commit('loading')
          this.$http.post("/api/agentZoneMng/area/modelGroup" , {params: {catNm: this.modelNm || ''}}
          ).then(response => {
            if(response.data){
              this.rowData = response.data;
              // this.rowData = response.data.callModelSelPageList || []
            }

          }).finally(() => {
            this.$store.commit('finish')

          });
        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }

.pop_min2 {
  width: auto !important;
  min-width: 35% !important;
  overflow: hidden;
  }

}
</style>